import { ArcherContainer, ArcherElement } from "react-archer";
import React, { useState, useEffect, useMemo } from 'react';
import adwords from '../../../../../assets/images/adwords.png';
import meta from '../../../../../assets/images/meta.png';
import dv360 from '../../../../../assets/images/dv360.png';
import tiktok from '../../../../../assets/images/tiktok.png';
import viads from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/vodafone.png";
import Loading from '../../../../../assets/images/Recommended.gif';
import { recommendedPlanAction } from "../../../../../actions/recommendedPlan";
import { useDispatch, useSelector } from "react-redux";
import { get, sum } from "lodash";
// import "./styles.css";
import moment from 'moment';
import { getCurrentDateInTimeZone, getTenantCurrency, getUserSelectedDateInUtc, isApiCallSuccess } from "../../../../../selectors";
import { getCampaignActionWithoutLoader } from "../../../../../actions/campaign";

const rootStyle = {
  position: "absolute",
  left: "80%",
  width: 500,
  height: 100,
  top: 30
};
const rowStyle = {
  position: "absolute",
  left: 0,
  top: 0,
  width: "65%",
  height: 100
};
const boxStyle = { padding: "20px", border: "1px solid black", marginTop: 10 };
const scrollStyle = {
  height: "300px",
  overflow: "auto"
};
const trapezium = {
  paddingRight: "0px",
  border: "1px solid transparent",
  borderBottom: "0px solid transparent",
  position: "relative"
};


const targets = [
  { key: 1, value: "Awareness", color: "#00A7A4", strokeColor: "#00A7A4" },
  { key: 2, value: "Interest", color: "#FFDE86", strokeColor: "#FFDE86" },
  { key: 3, value: "Desire", color: "#FE5D66", strokeColor: "#FE5D66" },
  { key: 4, value: "Action", color: "#50274A", strokeColor: "#50274A" }
];

function calculateMarginLeft(index) {
  const marginFactor = -19;
  const marginWidth = 10 - index * marginFactor;
  return `${marginWidth}px`;
}

function calculateTrapeziumWidth(index) {
  const widthFactor = 38;
  const trapeziumWidth = 212 - index * widthFactor;
  return `${trapeziumWidth}px`;
}

function calculatePadding(index) {
  const paddingFactor = 2;
  const paddingValue = 10 - index * paddingFactor;
  return `${paddingValue}px`;
}

function calculateBorderWidth(index) {
  const factor = 1;
  const borderWidth = 20 - index * factor;
  return `${borderWidth}px solid transparent`;
}


function getPlatformImage(platform) {
  switch (platform) {
    case 'ads':
      return adwords;
    case 'meta':
      return meta;
    case 'dv360':
      return dv360;
    case 'viads':
      return viads;
    // Add more cases for other platforms
    default:
      return null;
  }
}

function getRelationColor(platform, targetIndex) {
  const colorMappings = {
    ads: [null, "#FFDE86", null, "#50274A"],
    meta: ["#00A7A4", null, "#FE5D66", null],
    dv360: [null, "#FFDE86", null, "#50274A"],
    viads: ["#00A7A4", null, "#FE5D66", null],
    // Add more platforms and their color mappings as needed
  };

  return colorMappings[platform][targetIndex];
}


export default function RecommendedPlans({targetTimeZone,...props}) {
  const [hoveredPlatform, setHoveredPlatform] = useState(null);
  const [loading, setLoading] = useState(true);
  const [height, setHeight] = useState(300); // State to hold the dynamic height
  const [planData, setPlanData] = useState({});

  const configurationList = useSelector(state => get(state, 'app.configurationData.responseList', []));
  const campaignListAllReport = useSelector(state => get(state, 'app.campaignListAllReport.responseList', []));
  const tenantId = useSelector(state => get(state, 'app.preSignInState.tenantId', ''));
  const userId = useSelector(state => get(state, 'app.preSignInData.userId', ''));
  const authToken = useSelector(state => get(state, 'app.signInData.authToken', ''));
  const reduxCurrencyData = useSelector((state) =>
    get(state, "app.allCurrencyData", "")
  );

  const currency = useMemo(() => {
    let currency = "";
    if (reduxCurrencyData && reduxCurrencyData.responseList) {
      const { tenantId } = props;
      const findCurrencyData = reduxCurrencyData.responseList.find(
        (data) => data.key == getTenantCurrency(tenantId)
      );
      if (findCurrencyData) {
        currency = findCurrencyData.value;
      }
    }
    return currency;
  }, [reduxCurrencyData]);

  const dispatch = useDispatch();
  // const [responseData, setResponseData] = useState(/* your initial state */);
  // console.log("hoveredPlatform", hoveredPlatform)

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Simulate a 6-second delay
        const { match : { params : { id}}} = props;
        const params = {
          plan:"reco",
          mandateId:id ? id : sessionStorage.getItem('campaignIdCreated')
        }
        await dispatch(getCampaignActionWithoutLoader({tenantId,authToken,userId,params})).then((data)=>{
          const { responseCode: { status = ""} , responseObj = {}} = data;
          setLoading(false);
          if(isApiCallSuccess(status) && Object.keys(responseObj).length > 0){
            setPlanData(responseObj);
            const payload = {
              "ads": [],
              "meta": [],
              "dv360": [],
              "viads": [],
              "ion": [],
              "tiktok": []
            };
            Object.keys(responseObj).forEach((key) => {
              payload[key] = responseObj[key].map((item) => ({
                "campaignName": item.campaign_name,
                "type": item.content_type,
                "startDate": item.startDate,
                "endDate": item.endDate,
                "totalBudget": item.budget,
                "pacingType": item.pacing,
                "duration": item.duration,
                "campaignId": null,
                "strategyId": null,
                "status": 3,
                "isReco": 1,
                "isRecActive": 3
        
              }));
            });
            // console.log(payload);
            dispatch(
              recommendedPlanAction({
                recommendedPlanData: { payload }
              })
            );
          }
        }).catch((err)=>{
          setLoading(false);
        })
        // setTimeout(async () => {
        //   await DSRecommendApiCall();
        //   setLoading(false);
        // }, 3500);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array to run the effect only once


  const currentDate = moment(getCurrentDateInTimeZone(targetTimeZone));
  const endDate = moment(getCurrentDateInTimeZone(targetTimeZone)).add(1, 'days'); // Adding 10 days to the current date

  const formattedStartDate = getUserSelectedDateInUtc({
    date: currentDate,
    targetTimeZone: targetTimeZone,
    isStartDate: true,
  });
  const formattedEndDate = getUserSelectedDateInUtc({
    date: endDate,
    targetTimeZone: targetTimeZone,
    isStartDate: false,
  });
  const responseData = {
    "responeCode": {
      "status": "success",
      "code": 200,
      "msg": "Recommended plan generated successfully"
    },
    "response": {
      "ads": [
        // {
        //   "content_type": "search",
        //   "campaign_name": "(MandateName)_(ads)_(content_type)",
        //   "impressions": 10000,
        //   "clicks": 1000,
        //   "budget": 100,
        //   "duration": "daily",
        //   "pacing": "Even",
        //   "startDate": formattedStartDate,
        //   "endDate": formattedEndDate
        // }
        {
          "content_type": 0,
          "campaign_name": "test_june21_0345_ads_display",
          "budget": "10.0",
          "duration": 5,
          "pacing": 1,
          "startDate": "2024-06-28 10:57:14",
          "endDate": "2024-07-06 10:57:14"
      },
      {
          "content_type": 2,
          "campaign_name": "test_june21_0345_ads_search",
          "budget": "10.0",
          "duration": 5,
          "pacing": 1,
          "startDate": "2024-06-28 10:57:14",
          "endDate": "2024-07-06 10:57:14"
      }
      ],
      // "meta": [
      //   {
      //     "content_type": "video",
      //     "campaign_name": "(MandateName)_(meta)_(content_type)",
      //     "impressions": 20000,
      //     "clicks": 2000,
      //     "budget": 600,
      //     "duration": "daily",
      //     "pacing": "even",
      //     "startDate": formattedStartDate,
      //     "endDate": formattedEndDate
      //   }
      // ],
      // "dv360": [
      //   {
      //     "content_type": "display",
      //     "campaign_name": "(MandateName)_(dv360)_(content_type)",
      //     "impressions": 30000,
      //     "clicks": 3000,
      //     "budget": 100,
      //     "duration": "daily",
      //     "pacing": "even",
      //     "startDate": formattedStartDate,
      //     "endDate": formattedEndDate
      //   }
      // ],
    }
  };


  useEffect(() => {
    const keysCount = Object.keys(planData).length;
    // Set the height based on the number of keys
    if (keysCount > 3) {
      // Increase height for more than 3 keys
      setHeight(keysCount * 100); // Increase height by 100px per key
    }
  }, [planData]);

  const getType = (key) => {
    switch (key) {
      case 0:
        return 'Display';
      case 1:
        return 'Video';
      case 2:
        return 'Search';
      default:
        return '-';
    }
  };

  const DSRecommendApiCall = async () => {


    // await dispatch(getCampaignFilterAction({ tenantId, authToken, userId })).then((data) => {

    //   const {
    //     responseCode: { status = "" },
    //     responseObj,
    //   } = data;

    //   if (status === "Success") {

    // Initialize the payload with an empty ads array
    const payload = {
      "ads": [],
      "meta": [],
      "dv360": [],
      "viads": [],
      "ion": [],
      "tiktok": []
    };


    // Helper function to get the type based on the key
    const getType = (key) => {
      switch (key) {
        case 0:
          return 'Display';
        case 1:
          return 'Video';
        case '2':
          return 'Search';
        default:
          return '-';
      }
    };

    // Helper function to get the pacing type
    const getPacingType = (pacing) => {
      switch (pacing.toLowerCase()) {
        case 'even':
          return 1;
        case 'asap':
          return 3;
        default:
          return null;
      }
    };

    // Helper function to get the duration
    const getDuration = (duration) => {
      switch (duration.toLowerCase()) {
        case 'daily':
          return 5;
        case 'lifetime':
          return 7;
        default:
          return null;
      }
    };


    // Transform each response array into the desired format and push it into the payload
    Object.keys(responseData.response).forEach((key) => {
      payload[key] = responseData.response[key].map((item) => ({
        "campaignName": item.campaign_name,
        "type": item.content_type,
        "startDate": item.startDate,
        "endDate": item.endDate,
        "totalBudget": item.budget,
        "pacingType": item.pacing,
        "duration": item.duration,
        "campaignId": null,
        "strategyId": null,
        "status": 3,
        "isReco": 1,
        "isRecActive": 3

      }));
    });
    dispatch(
      recommendedPlanAction({
        recommendedPlanData: { payload }
      })
    );

    console.log("payload", payload);

    // } else {
    //   console.log("List data not found");
    // }
    // })
    // .catch((err) => {
    //   console.error(err);
    // });
  };

  const getPlatformData = (platformData,type) => {
    let value = '';

    if(type == 'contentType'){
      const contentType = platformData.map((data)=> getType(data.content_type));
      value = contentType.join(', ')
    }
    else{
      const budget = platformData.map((data)=> parseFloat(data.budget));
      // console.log(budget);
      value =  sum(budget)
    }


    return value;
  }


  // console.log('loading', loading)
  return (
    <div style={{ height: `${height}px` }}> {/* Set the dynamic height */}
      {loading &&
        <div class="d-flex justify-content-center flex-column align-items-center">
          <div className="" style={{ fontSize: 16 }}><strong>Hold on!</strong> AI is working on to create best media plan for you</div>
          <img src={Loading} alt="Loading..." style={{ height: 321 }} />
        </div>
      }
      {!loading &&
        <ArcherContainer style={{ height: "inherit" }} strokeColor="black">
          <div style={rootStyle}>
            <div style={scrollStyle}>
              {targets.map((t, i) => (
                <ArcherElement key={i} id={`root${i}`}>
                  <div
                    style={{
                      ...trapezium,
                      borderLeft: calculateBorderWidth(i),
                      borderRight: calculateBorderWidth(i),
                      // padding: calculatePadding(i),
                      width: calculateTrapeziumWidth(i),
                      marginLeft: calculateMarginLeft(i),
                      borderTop: `60px solid ${t.color}`,
                      // opacity: hoveredPlatform ? 1 : 0.3, // Adjust opacity based on hover state
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: -40,
                        left: `${46 - i * 13}px`,
                        color: "#fff",
                        fontWeight: 600
                      }}
                    >
                      {t.value}
                    </div>
                  </div>
                </ArcherElement>
              ))}
            </div>
          </div>

          <div style={rowStyle}>
            {Object.entries(planData).map(([platform, platformData], index) => (
              // console.log("platform", platformData[0]),
              <ArcherElement
                key={index}
                id={`element${index + 4}`}
                relations={targets.map((t, i) => {
                  const relationColor = getRelationColor(platform, i);

                  return relationColor
                    ? {
                      targetId: `root${i}`,
                      targetAnchor: "left",
                      sourceAnchor: "right",
                      style: {
                        strokeColor: relationColor,
                        endShape: {
                          circle: { radius: 2, fill: true, fillColor: relationColor, strokeColor: relationColor, strokeWidth: 1 }
                        },
                        startMarker: true,
                        endMarker: true,
                      }
                    }
                    : null;
                }).filter((relation) => relation !== null)}

              >
                <div className={`platform highlight`}
                // onMouseEnter={() => setHoveredPlatform(platform)}
                // onMouseLeave={() => setHoveredPlatform(null)}
                >
                  <div className='d-flex align-items-center'>
                    <img style={{ margin: "0 8px", maxWidth: 25 }} src={getPlatformImage(platform)} alt={platform} />
                    <div style={{ textTransform: "capitalize" }} className='checkbox-title'>{platform}</div>
                  </div>
                  <div className='d-flex align-items-center'>
                    <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
                      <h6 style={{ fontSize: 11 }}>Media Type</h6>
                      <p style={{ fontSize: 12, textTransform: "capitalize" }}>{getPlatformData(platformData,'contentType') }</p>
                    </div>
                    {/* <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
                      <h6 style={{ fontSize: 11 }}>Impressions</h6>
                      <p style={{ fontSize: 12 }}>{platformData[0].impressions}</p>
                    </div>
                    <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
                      <h6 style={{ fontSize: 11 }}>Clicks</h6>
                      <p style={{ fontSize: 12 }}>{platformData[0].clicks}</p>
                    </div> */}
                    <div><span style={{ color: "#1B2559", fontSize: 20, fontWeight: 600 }}> {getPlatformData(platformData,'budget')} ({currency}) </span> / day</div>
                  </div>
                </div>
              </ArcherElement>
            ))}
          </div>
        </ArcherContainer>
      }
    </div>
  );
}
